/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import { saveSignalsListLocation } from '../helpers/save-and-send-location';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'var(--color-colorPrimary-main)',
  },
  skeleton: {
    '&.MuiSkeleton-root': {
      backgroundColor: 'var(--color-backgroundColors-disabled)',
    },
  },
}));

const CellName = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const name = useSelector((state) => {
    const { name = '' } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return name;
  });

  const handleRedirectToEdit = () => {
    saveSignalsListLocation();

    history.push(`/signals/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToEdit}>
      {name}
    </div>
  );
};

export default CellName;
